import styled from 'styled-components';

export const UiQuestionnairePreviewPage = styled.div`
	display: block;
`;